import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { Events } from "@ionic/angular";
import { v4 as uuidv4 } from "uuid";
import { IonicUtilService } from "../../../services/ionic-util.service";

@Component({
  selector: "app-autocomplete-selector",
  templateUrl: "./autocomplete-selector.component.html",
  styleUrls: ["./autocomplete-selector.component.scss"],
})
export class AutocompleteSelectorComponent implements OnInit {
  @Input() items: Array<any> = [];
  @Input() clear: boolean;
  @Input() complete: boolean;
  @Input() placeholder: string;
  @Input() alternativeIcon: boolean;
  @Input() noInput: boolean;
  @Output() result = new EventEmitter();
  @Output() dataChange = new EventEmitter<any>();

  id = uuidv4();
  query: any = "";
  selected: any;
  sugestoes: Array<any> = [];

  constructor(private ev: Events, private util: IonicUtilService) {
    this.ev.subscribe("CLEAR_INPUT", () => {
      if (this.clear) {
        this.query = "";
      }
    });

    this.ev.subscribe("OPEN_SUGGESTIONS", (id) => {
      if (this.id !== id) {
        this.sugestoes = [];
      }
    });
  }

  ngOnInit() { }

  pesquisar() {
    console.log('entrei');
    if (!this.selected) {
      this.sugestoes = [];
      if (this.query.length) {
        console.log('query', this.query.length);
        this.items.forEach((item) => {
          if (item.toLowerCase().search(this.query.toLowerCase()) !== -1) {
            const exist = this.sugestoes.find((sugestao) => {
              return sugestao === item;
            });
            if (!exist) {
              this.sugestoes.push(item);
            }
          }
        });

        this.ev.publish("OPEN_SUGGESTIONS", this.id);
      } else {
        console.log('query f', this.query.length);
        this.items.forEach((item) => {
          this.sugestoes.push(item);
        });
      }
    } else {
      this.selected = null;
    }
  }

  limparSugestoes() {
    this.sugestoes = [];
    this.result.emit(undefined);
  }

  clearQuery() {
    this.selected = true;
    this.query = "";
    this.sugestoes = [];
    this.result.emit(undefined);
  }

  async showAllSugestoes() {
    if (!this.items.length) {
      this.sugestoes = [];
    } else {
      Object.assign(this.sugestoes, this.items);
      this.ev.publish("OPEN_SUGGESTIONS", this.id);
    }
  }

  selectQuery(sugestao) {
    this.sugestoes = [];
    this.selected = sugestao;
    if (this.complete) {
      this.query = sugestao;
    }
    this.result.emit(sugestao);
    this.dataChange.emit(sugestao);
  }
}
